import config from './configureStore';

export default config;
